import * as types from "./types";

const setIsOpenAgeVerificationProcessModalAction = (bool) => ({
   type: types.SET_IS_OPEN_AGE_VERIFICATION_PROCESS_MODAL,
   payload: bool,
})

const setIsOpenAgeVerifiedModalAction = (bool = false) => ({
   type: types.SET_IS_OPEN_AGE_VERIFIED_MODAL,
   payload: bool,
})

export {
   setIsOpenAgeVerificationProcessModalAction,
   setIsOpenAgeVerifiedModalAction,
}
